import { BUYER_PROGRAM_LOAN_TYPE } from "../../../clients/real-estate-tab/buyer-program/utils";

export const ALL_ACTIVE_PROGRAMS = [
    "Address Removal",
    "Bankruptcy",
    "Book Keeping",
    "Business VIP",
    "Buyer",
    "Club Fico Guaranteed",
    "Copy Title",
    "Corporations",
    "Credit Report",
    // "Credito y Casas",
    "Document Preparation",
    "Funding",
    // "Homestead",
    // "ID Theft",
    // "ID Theft Alert",
    "Inquiries",
    "Judgement",
    "Living Trust",
    "Mailing Address",
    "Mortgage",
    "New Credit Card",
    "Policy",
    // "Public Records",
    "Rapid Rescore",
    "Refinancing",
    "Regular",
    "Remove Disputes",
    "RFV",
    // "Score Simulator",
    "Seller",
    "Single Negotiation",
    "Taxes",
    "Tradelines",
    // "Tradelines Funding",
    "VIP Credit",
    "VOE",
    "Wage Garnishments",
    "Zero to Hero",
];

// CLRDC-2185: only these programs support the internal/external payment toggle
export const EXTERNAL_PAYMENT_ELIGIBLE_PROGRAMS = [
    "Corporations",
    "Book Keeping",
    "Taxes",
    "Living Trust",
    "Policy",
    "Copy Title",
    "Document Preparation",
];

const ALL_PROGRAMS = [
    "Address Removal",
    "Bankruptcy",
    "Book Keeping",
    "Business VIP",
    "Buyer",
    "Club Fico Guaranteed",
    "Corporations",
    "Credit Report",
    "Credito y Casas",
    "Funding",
    "Homestead",
    "ID Theft",
    "ID Theft Alert",
    "Inquiries",
    "Judgement",
    "Living Trust",
    "Mailing Address",
    "Mortgage",
    "New Credit Card",
    "Public Records",
    "Rapid Rescore",
    "Refinancing",
    "Regular",
    "Remove Disputes",
    "RFV",
    "Score Simulator",
    "Seller",
    "Single Negotiation",
    "Taxes",
    "Tradelines",
    "Tradelines Funding",
    "VIP Credit",
    "VOE",
    "Wage Garnishments",
    "Zero to Hero",
]

export const CLUBS = [
    "CLUB 620",
    // "CLUB 620 CV",
    "CLUB 640",
    "CLUB 660",
    "CLUB 680",
    "CLUB 700",
    "CLUB 720",
    "CLUB 740",
    "CLUB 760",
    "CLUB 780",
    "CLUB 800",
];

export const ALL_FUNDINGS = ["Funding - Business", "Funding - Personal", "Funding - Equity"];

export const ALL_TRADELINES = ["Tradelines", "Tradelines Funding", "Tradelines Borrower"];
export const ALL_TRADELINE_TYPES = ["Regular", "Funding", "Borrower"];

export const ALL_CLUBS = [
    "CLUB 620",
    "CLUB 620 CV",
    "CLUB 640",
    "CLUB 660",
    "CLUB 680",
    "CLUB 700",
    "CLUB 720",
    "CLUB 740",
    "CLUB 760",
    "CLUB 780",
    "CLUB 800",
    "CLUB 620 2nd Contract",
    "CLUB 620 CV 2nd Contract",
    "CLUB 640 2nd Contract",
    "CLUB 660 2nd Contract",
    "CLUB 680 2nd Contract",
    "CLUB 700 2nd Contract",
    "CLUB 720 2nd Contract",
    "CLUB 740 2nd Contract",
    "CLUB 760 2nd Contract",
    "CLUB 780 2nd Contract",
    "CLUB 800 2nd Contract",
    "CLUB 620 + Address Removal",
    "CLUB 640 + Address Removal",
    "CLUB 660 + Address Removal",
    "CLUB 680 + Address Removal",
    "CLUB 700 + Address Removal",
    "CLUB 720 + Address Removal",
    "CLUB 740 + Address Removal",
    "CLUB 760 + Address Removal",
    "CLUB 780 + Address Removal",
    "CLUB 800 + Address Removal",
    "CLUB 620 VIP",
    "CLUB 640 VIP",
    "CLUB 660 VIP",
    "CLUB 680 VIP",
];


export const PROGRAM_DROPDOWN_OPTIONS = [
    ...ALL_PROGRAMS.filter((p) => p !== "Club Fico Guaranteed" && p !== "Funding" && p !== "Tradelines"),
    ...ALL_CLUBS,
    ...ALL_FUNDINGS,
    ...ALL_TRADELINES
].sort();

export const CLUBS_TYPES = [
    "Regular",
    "Regular + Address Removal",
    "2nd Contract",
    // "VIP"
];

export const ZERO_TO_HERO_TYPES = ["Regular", "CV"];

export const PROGRAM_STATUS = ["ACTIVE", "HOLD", "CANCELED", "COMPLETED"];

export const TRADELINE_STATUS = [
    "Needs Tradeline",
    "Tradeline Ordered",
    "Tradeline Completed",
    "Needs New Credit",
    "New Credit Completed",
];

export const FUNDING_TYPES = ["Business", "Personal", "Equity"];
export const FUNDING_TYPES_CREDIT_LINE = [
    "BCC (Business Credit Card)",
    "PCC (Personal Credit Card)",
    "Equity",
    "BLOC (Business Line of Credit)",
    "BL (Business Loan)",
];

const PRICE_COST_FIELDS = (
    width1: string,
    width2: string,
    validate: boolean,
    priceAutomated?: (options: any) => number | null
) => [
        {
            title: "Cost",
            accesKey: "cost",
            required: true,
            type: "Money",
            width: width1 === "" ? "sm:col-span-3 col-span-8" : width1,
            editable: false,
            finalValidation: validate,
            onlyFinal: validate,
            includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
        },
        {
            title: "Price",
            accesKey: "price",
            required: true,
            type: "Money",
            width: width2 === "" ? "sm:col-span-3 col-span-8" : width2,
            editable: priceAutomated === undefined,
            finalValidation: validate,
            finalValidationEditable: true,
            onlyFinal: validate,
            includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
            automated: priceAutomated,
        },
        SPECIAL_PRICING_FIELD(),
    ];

const SPECIAL_PRICING_FIELD = (
    width: string = "lg:col-span-2 sm:col-span-2 col-span-8",
    title: string = "Special Pricing"
) => ({
    title,
    accesKey: "special_pricing",
    type: "Checkbox",
    width,
    editable: true,
    validate: true,
    finalValidationEditable: false,
    required: false,
    includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
});

interface PaymentFieldsOptions {
    estimated_deposit?: {
        editable?: boolean;
        automated?: (options: any) => number;
    };
    estimated_monthly?: {
        hidden?: boolean;
    };
    fieldValidate?: {
        validate: (value: any) => boolean;
        message: string;
    };
}

const ESTIMATED_DEPOSIT_FIELD = (
    final: boolean = false,
    width: string = "lg:col-span-4 sm:col-span-2 col-span-8",
    options: PaymentFieldsOptions = {}
) => [
        {
            title: "Estimated Deposit",
            accesKey: "estimated_deposit",
            required: false,
            type: "Money",
            width,
            editable:
                options.estimated_deposit?.editable === undefined
                    ? true
                    : options.estimated_deposit.editable,
            validationEditable: true,
            finalValidation: final,
            finalValidationEditable: true,
            onlyFinal: final,
            includeInType: ["Regular", "2nd Contract", "VIP"],
            automated: options.estimated_deposit?.automated,
            fieldValidate: options.fieldValidate,
        },
    ];

const EXTRA_FIELDS_ACCOUNTS = () => [
    {
        title: "Num. Collections",
        accesKey: "num_collections",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
    {
        title: "Num. Disputes",
        accesKey: "num_disputes",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
    {
        title: "Num. Inquiries",
        accesKey: "num_inquiries",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
    {
        title: "Num. Public Records",
        accesKey: "num_public_records",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
    {
        title: "Num. Open Accounts",
        accesKey: "num_open_accounts",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
];

const CREDIT_SCORES_FIELDS = () => [
    {
        title: "Equifax Score",
        accesKey: "eq",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
    {
        title: "Transunion Score",
        accesKey: "tu",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
    {
        title: "Experiean Score",
        accesKey: "ex",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: true,
        validate: true,
        finalValidationEditable: true,
    },
    {
        title: "MID Fico",
        accesKey: "mid_fico",
        required: false,
        type: "Number",
        width: "col-span-4 sm:col-span-2",
        editable: false,
        validate: true,
        finalValidationEditable: true,
        automated: ({ ex, tu, eq }: any) => {
            const scores = [Number(ex), Number(tu), Number(eq)].sort((a, b) => a - b).filter(s => s);
            // If all three scores are available, return the middle one
            if (scores.length === 3) return scores[1]
            // If only two scores are available, return the lower one
            if (scores.length === 2) return scores[0]
            // If only one score is available, return that one
            if (scores.length === 1) return scores[0]
            return null;
        }
    },
];

export const CREDIT_REPORT = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "lg:col-span-4 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const TRADELINES = {
    validate: true,
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-4 col-span-8",
            search: "Programs",
            editable: false,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Type",
            accesKey: "tradelines_type",
            required: true,
            type: "Dropdown",
            options: ALL_TRADELINE_TYPES,
            width: "sm:col-span-4 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Accounts",
            accesKey: "accounts",
            required: true,
            type: "Accounts",
            width: "sm:col-span-4 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Number of tradelines",
            accesKey: "tradelines",
            required: true,
            type: "Number",
            width: "sm:col-span-4 col-span-8",
            editable: true,
            validate: true,
            automated: ({ accounts_positive, accounts_negative }: any) => {
                if (accounts_negative <= 8)
                    return 2 - accounts_positive > 0 ? 2 - accounts_positive : 0;
                else return 3 - accounts_positive > 0 ? 3 - accounts_positive : 0;
            },
            finalValidationEditable: false,
        },
        ...EXTRA_FIELDS_ACCOUNTS(),
        ...PRICE_COST_FIELDS("", "", true),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "lg:col-span-8",
            required: true,
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const SINGLE_NEGOTIATION = {
    validate: true,
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-5 col-span-8",
            search: "Programs",
            editable: false,
            validate: true,
        },
        {
            title: "Accounts",
            accesKey: "accounts",
            required: true,
            type: "Accounts",
            width: "sm:col-span-3 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Collections",
            accesKey: "collections",
            required: true,
            type: "Collections",
            options_amount: ["$1 to $1000", "$1001 to $2000", "$2001 to $3000", "$3001 to $..."],
            width: "lg:col-span-4 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        ...EXTRA_FIELDS_ACCOUNTS(),
        ...PRICE_COST_FIELDS("", "", true),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "col-span-8",
            required: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const ADDRESS_REMOVAL = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-8 col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const RFV = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const JUDGEMENT = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const BANKRUPTCY = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-4 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "BK Type",
            accesKey: "bk_type",
            required: true,
            type: "Dropdown",
            options: ["SINGLE BK", "JOINT BK"],
            width: "sm:col-span-4 col-span-8",
            editable: true,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const CLUB_FICO_GUARANTEED = {
    popupWidth: "w-[900px]",
    validate: true,
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-5",
            search: "Programs",
            editable: false,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Club Type",
            accesKey: "club_type",
            required: true,
            type: "Dropdown",
            options: [...CLUBS_TYPES],
            getOptions: ({ qualifies_second_contract }: { qualifies_second_contract?: boolean }) => {
                if (qualifies_second_contract) return [...CLUBS_TYPES]
                return [...CLUBS_TYPES.filter(ct => ct !== "2nd Contract")];
            },
            width: "lg:col-span-3 sm:col-span-4 col-span-8",
            validate: true,
            editable: true,
            finalValidationEditable: false,
        },
        ...CREDIT_SCORES_FIELDS(),
        {
            title: "Desired Club",
            accesKey: "club",
            required: true,
            type: "Dropdown",
            options: [...CLUBS],
            getOptions: ({ mid_fico, eq, ex, tu, mix_social_itin }: { mid_fico?: number, eq?: number, ex?: number, tu?: number, mix_social_itin?: boolean }) => {
                // Filter club types based on mid_fico
                if (mix_social_itin) return ["CLUB 620"];
                const scores = [eq, ex, tu].filter(s => s !== undefined);
                const scores0 = [eq, ex, tu].filter(s => String(s) === '0' || s === 0);
                if (scores.length === 3 && scores0.length === 2) return ["CLUB 620"];
                if (!mid_fico || mid_fico < 600) return ["CLUB 620"];
                if (mid_fico >= 600 && mid_fico < 620) return ["CLUB 620", "CLUB 640"];
                if (mid_fico >= 620 && mid_fico < 640) return ["CLUB 640", "CLUB 660"];
                if (mid_fico >= 640 && mid_fico < 660) return ["CLUB 660", "CLUB 680"];
                if (mid_fico >= 660 && mid_fico < 680) return ["CLUB 680", "CLUB 700"];
                if (mid_fico >= 680 && mid_fico < 700) return ["CLUB 700", "CLUB 720"];
                if (mid_fico >= 700 && mid_fico < 720) return ["CLUB 720", "CLUB 740"];
                if (mid_fico >= 720 && mid_fico < 740) return ["CLUB 740", "CLUB 760"];
                if (mid_fico >= 740 && mid_fico < 760) return ["CLUB 760", "CLUB 780"];
                if (mid_fico >= 760 && mid_fico < 780) return ["CLUB 780", "CLUB 800"];
                return ["CLUB 800"];
            },
            width: "lg:col-span-6 sm:col-span-4 col-span-8",
            search: "Programs",
            validate: true,
            editable: true,
            finalValidationEditable: false,
            includeInType: ["Regular", "Regular + Address Removal", "2nd Contract"],
        },
        {
            title: "Mix Social & ITIN",
            accesKey: "mix_social_itin",
            type: "Checkbox",
            width: "lg:col-span-2 sm:col-span-4 col-span-8",
            required: false,
            includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
            editable: true,
            validate: true,
            finalValidationEditable: true,
        },
        // {
        //     title: "Desired Club",
        //     accesKey: "club",
        //     required: true,
        //     type: "Dropdown",
        //     options: ["CLUB 620", "CLUB 640", "CLUB 660", "CLUB 680"],
        //     width: "lg:col-span-3 sm:col-span-4 col-span-8",
        //     search: "Programs",
        //     validate: true,
        //     editable: true,
        //     finalValidationEditable: false,
        //     includeInType: ["VIP"],
        // },
        {
            title: "Accounts",
            accesKey: "accounts",
            required: true,
            type: "Accounts",
            width: "sm:col-span-4 col-span-8",
            validate: true,
            editable: true,
            finalValidationEditable: false,
            includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
        },
        {
            title: "Repositions 🚙",
            accesKey: "repositions",
            required: false,
            type: "Number",
            width: "col-span-4 sm:col-span-2",
            editable: true,
            validate: true,
            finalValidationEditable: true,
        },
        {
            title: "Tradelines",
            accesKey: "tradelines",
            required: true,
            type: "Dropdown",
            options: ["0", "1", "2", "3"],
            width: "lg:col-span-2 sm:col-span-4 col-span-8",
            validate: true,
            editable: false,
            finalValidationEditable: false,
            automated: ({ accounts_positive, accounts_negative }: any) => {
                if (accounts_negative <= 8)
                    return 2 - accounts_positive > 0 ? 2 - accounts_positive : 0;
                else return 3 - accounts_positive > 0 ? 3 - accounts_positive : 0;
            },
            includeInType: ["Regular", "Regular + Address Removal"],
        },
        ...EXTRA_FIELDS_ACCOUNTS(),
        {
            title: "State",
            accesKey: "state",
            required: true,
            type: "Dropdown",
            options: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
                "AS",
                "AA",
                "AE",
                "AP",
                "PW",
                "DC",
                "VI",
                "PR",
                "FM",
                "MP",
                "GU",
            ],
            width: "lg:col-span-2 sm:col-span-4 col-span-8",
            editable: true,
            finalValidationEditable: false,
            includeInType: ["Regular", "Regular + Address Removal"],
        },
        {
            title: "Zipcode",
            accesKey: "zip",
            required: false,
            type: "Input",
            width: "col-span-4 sm:col-span-2",
            editable: true,
            validate: true,
            finalValidationEditable: true,
        },
        ...PRICE_COST_FIELDS("lg:col-span-2 sm:col-span-4 col-span-8", "lg:col-span-2 sm:col-span-4 col-span-8", true),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        //{ ...SPECIAL_PRICING_FIELD("lg:col-span-2 sm:col-span-2 col-span-8") },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "col-span-8",
            validate: true,
            required: true,
            includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
        },
    ],
};

export const MANUAL_PROGRAM = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
    ],
};

export const INQUIRIES = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-4 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Number of Inquiries",
            accesKey: "inquiries",
            required: true,
            type: "Number",
            typeInput: "number",
            width: "sm:col-span-4 col-span-8",
            editable: true,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const RAPID_RESCORE = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "md:col-span-6 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Bureaus",
            accesKey: "bureaus",
            required: true,
            type: "Bureaus",
            width: "md:col-span-2 col-span-8",
            editable: true,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const ID_THEFT_ALERTS = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Bureaus",
            accesKey: "bureaus",
            required: true,
            type: "Bureaus",
            width: "md:col-span-2 col-span-8",
            editable: true,
        },
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const ID_THEFT = {
    popupWidth: "w-[900px]",
    validateWidth: "w-[700px]",
    validate: true,
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
            validate: true,
            validateWidth: "lg:col-span-4",
        },
        ...PRICE_COST_FIELDS("", "", true),
        {
            title: "Accounts",
            accesKey: "accounts",
            required: true,
            type: "Accounts",
            width: "lg:col-span-4 sm:col-span-4 col-span-8 mt-[0.2rem]",
            editable: true,
            validate: true,
            finalValidationEditable: false,
            validateWidth: "lg:col-span-4",
        },
        ...EXTRA_FIELDS_ACCOUNTS(),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "lg:col-span-8",
            validate: true,
            required: true,
        },
    ],
};

export const PUBLIC_RECORDS = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-6 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Number of Records",
            accesKey: "records",
            required: true,
            type: "Dropdown",
            options: ["1", "2", "3"],
            width: "sm:col-span-2 col-span-8",
            editable: true,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const MAILING_ADDRESS = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false, (options) => Number(options.cost || 0)),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const SCORE_SIMULATOR = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-5 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Number of Simulations",
            accesKey: "simulations",
            required: true,
            type: "Dropdown",
            options: ["1", "2", "3"],
            width: "sm:col-span-3 col-span-8",
            editable: true,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const REGULAR = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const NEW_CREDIT_CARD = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false, ({ amount_approved }: any) => {
            const price = parseFloat((0.1 * amount_approved).toFixed(2));
            return price > 450 ? price : 450;
        }),
        {
            title: "Amount Approved",
            accesKey: "amount_approved",
            required: true,
            type: "Money",
            width: "lg:col-span-8 sm:col-span-4 col-span-8",
            editable: true,
            finalValidation: false,
            onlyFinal: false,
        },
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const REMOVE_DISPUTES = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Account Numbers",
            accesKey: "account_numbers",
            type: "AccountNumbers",
            width: "lg:col-span-8 sm:col-span-8 col-span-8",
            required: true,
            editable: true,
        },
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const HOMESTEAD = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Property Value",
            accesKey: "property_value",
            required: true,
            type: "Money",
            width: "lg:col-span-8 sm:col-span-4 col-span-8",
            editable: true,
            finalValidation: false,
            onlyFinal: false,
        },
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const LIVING_TRUST = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-4 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Living Trust Type",
            accesKey: "living_trust_type",
            required: true,
            type: "Dropdown",
            options: ["Single", "Joint"],
            width: "sm:col-span-4 col-span-8",
            editable: true,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "State",
            accesKey: "state",
            required: true,
            type: "Dropdown",
            options: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
                "AS",
                "AA",
                "AE",
                "AP",
                "PW",
                "DC",
                "VI",
                "PR",
                "FM",
                "MP",
                "GU",
            ],
            width: "lg:col-span-4 sm:col-span-4 col-span-8",
            editable: true,
            finalValidationEditable: false,
        },
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const VIP_CREDIT = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-5 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Accounts",
            accesKey: "accounts",
            required: true,
            type: "Accounts",
            width: "sm:col-span-3 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        ...EXTRA_FIELDS_ACCOUNTS(),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const BUSINESS_VIP = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-8 col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const FUNDING = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-4 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Agent Commission",
            accesKey: "agent_commission",
            required: true,
            type: "Money",
            width: "sm:col-span-4 col-span-8",
            editable: false,
            finalValidation: false,
            onlyFinal: false,
            automated: () => 300,
        },
        {
            title: "% Commission",
            accesKey: "commission_percent",
            required: true,
            type: "Number",
            typeInput: "number",
            width: "lg:col-span-2 sm:col-span-4 col-span-8",
            editable: true,
            fieldValidate: {
                validate: (value: number) => {
                    return value >= 5;
                },
                message: "The commission must be at least 5%.",
            },
        },
        {
            title: "Tradelines",
            accesKey: "tradelines",
            required: true,
            type: "Number",
            typeInput: "number",
            width: "lg:col-span-2 sm:col-span-4 col-span-8",
            editable: true,
        },
        ...ESTIMATED_DEPOSIT_FIELD(undefined, undefined, {
            estimated_deposit: {
                automated: (options) => {
                    return options.funding_type !== "Equity" ? 2500 : 0;
                },
                editable: false,
            },
        }),
        {
            title: "Funding Type",
            accesKey: "funding_type",
            required: true,
            type: "Dropdown",
            options: FUNDING_TYPES,
            width: "sm:col-span-4 col-span-8",
            editable: true,
        },
        { ...SPECIAL_PRICING_FIELD(undefined, "Special Conditions") },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "lg:col-span-8",
            required: true,
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const TRADELINES_FUNDING = {
    validate: true,
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
            validate: true,
            finalValidationEditable: false,
        },
        ...PRICE_COST_FIELDS("", "", true, ({ accounts_positive, accounts_negative }: any) => {
            let tradelines = 0;
            if (accounts_negative <= 8)
                tradelines = 2 - accounts_positive > 0 ? 2 - accounts_positive : 0;
            else tradelines = 3 - accounts_positive > 0 ? 3 - accounts_positive : 0;
            return 1000 * tradelines;
        }),
        {
            title: "Accounts",
            accesKey: "accounts",
            required: true,
            type: "Accounts",
            width: "sm:col-span-4 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Number of tradelines",
            accesKey: "tradelines",
            required: true,
            type: "Number",
            width: "sm:col-span-4 col-span-8",
            editable: false,
            validate: true,
            automated: ({ accounts_positive, accounts_negative }: any) => {
                if (accounts_negative <= 8)
                    return 2 - accounts_positive > 0 ? 2 - accounts_positive : 0;
                else return 3 - accounts_positive > 0 ? 3 - accounts_positive : 0;
            },
            finalValidationEditable: false,
        },
        ...EXTRA_FIELDS_ACCOUNTS(),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "lg:col-span-8",
            required: true,
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const ZERO_TO_HERO = {
    popupWidth: "w-[900px]",
    validate: true,
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Type",
            accesKey: "type",
            required: true,
            type: "Dropdown",
            options: [...ZERO_TO_HERO_TYPES],
            width: "lg:col-span-4 sm:col-span-4 col-span-8",
            validate: true,
            editable: true,
            finalValidationEditable: false,
        },
        {
            title: "State",
            accesKey: "state",
            required: true,
            type: "Dropdown",
            options: [
                "AK",
                "AL",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY",
                "AS",
                "AA",
                "AE",
                "AP",
                "PW",
                "DC",
                "VI",
                "PR",
                "FM",
                "MP",
                "GU",
            ],
            width: "lg:col-span-2 sm:col-span-4 col-span-8",
            editable: true,
            finalValidationEditable: false,
            includeInType: ["Regular"],
        },
        {
            title: "Zipcode",
            accesKey: "zip",
            required: false,
            type: "Input",
            width: "col-span-4 sm:col-span-2",
            editable: true,
            validate: true,
            finalValidationEditable: true,
        },
        ...PRICE_COST_FIELDS("", "", true),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "col-span-8",
            validate: true,
            required: true,
            includeInType: ["Regular", "2nd Contract", "VIP"],
        },
    ],
};

export const BUYER = {
    popupWidth: "w-[900px]",
    validate: true,
    fields: [
        {
            title: "Loan Type",
            accesKey: "loan_type",
            required: true,
            type: "Dropdown",
            options: BUYER_PROGRAM_LOAN_TYPE,
            width: "col-span-8",
            validate: true,
            editable: true,
            finalValidationEditable: false,
        },
    ],
};

export const CORPORATIONS = {
    popupWidth: "w-[900px]",
    validate: true,
    fields: [
        ...PRICE_COST_FIELDS("", "", true, (options) => Number(options.cost || 0) + 100),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const VOE = {
    popupWidth: "w-[900px]",
    validate: true,
    fields: [
        ...PRICE_COST_FIELDS("", "", true),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const DOCUMENT_PREPARATION = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        ...PRICE_COST_FIELDS("", "", false, (options) => Number(options.cost || 0)),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const POLICY = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-4 col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Policy Type",
            accesKey: "policy_type",
            required: true,
            type: "Dropdown",
            options: ["Whole Life", "Final Expense", "Preneed", "Term", "IUL"],
            width: "sm:col-span-4 col-span-8",
            editable: true,
        },
        // Policy only has a max price in the catalog, no fixed cost/price. Cost is
        // freely typed by the agent (unlike PRICE_COST_FIELDS' locked Cost); Price
        // is locked and always mirrors whatever Cost currently is.
        {
            title: "Cost",
            accesKey: "cost",
            required: true,
            type: "Money",
            width: "sm:col-span-3 col-span-8",
            editable: true,
            finalValidation: false,
            onlyFinal: false,
            includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
        },
        {
            title: "Price",
            accesKey: "price",
            required: true,
            type: "Money",
            width: "sm:col-span-3 col-span-8",
            editable: false,
            finalValidation: false,
            finalValidationEditable: true,
            onlyFinal: false,
            includeInType: ["Regular", "2nd Contract", "VIP", "Regular + Address Removal"],
            automated: (options: any) => Number(options.cost || 0),
        },
        SPECIAL_PRICING_FIELD(),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const COPY_TITLE = {
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "col-span-8",
            search: "Programs",
            editable: false,
        },
        {
            title: "Number of Copies",
            accesKey: "num_copies",
            required: true,
            type: "Number",
            typeInput: "number",
            width: "sm:col-span-4 col-span-8",
            editable: true,
        },
        ...PRICE_COST_FIELDS("", "", false, (options) => Number(options.cost || 0)),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};

export const WAGE_GARNISHMENTS = {
    validate: true,
    popupWidth: "w-[900px]",
    fields: [
        {
            title: "Desired Program",
            accesKey: "name",
            required: true,
            type: "Dropdown",
            options: ALL_ACTIVE_PROGRAMS,
            width: "sm:col-span-5 col-span-8",
            search: "Programs",
            editable: false,
            validate: true,
        },
        {
            title: "Accounts",
            accesKey: "accounts",
            required: true,
            type: "Accounts",
            width: "sm:col-span-3 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Collections",
            accesKey: "collections",
            required: true,
            type: "Collections",
            options_amount: ["$1 to $1000", "$1001 to $2000", "$2001 to $3000", "$3001 to $..."],
            width: "lg:col-span-4 col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        ...EXTRA_FIELDS_ACCOUNTS(),
        ...PRICE_COST_FIELDS("", "", true),
        {
            title: "Payments",
            accesKey: "payments",
            required: false,
            type: "Payments",
            width: "col-span-8",
            editable: true,
            validate: true,
            finalValidationEditable: false,
        },
        {
            title: "Select the Credit Report from the Documents List",
            accesKey: "credit_report",
            type: "CreditReport",
            width: "col-span-8",
            required: true,
            validate: true,
            finalValidationEditable: false,
        },
    ],
};
